import { useLocation } from '@tanstack/react-router';

export const useIsTattooPage = (): boolean => {
  const location = useLocation();
  const pathname = location.pathname;
  return ['/tatouage', '/projet'].some((prefix) => pathname.startsWith(prefix));
};
